import { Injectable } from "@angular/core";
import { ArrayClientRepository } from "./abstract/array.client.repository";
import { ClientService } from "../services/client.service";

@Injectable({
  providedIn: "root",
})
export class IrefItemFvoRepository extends ArrayClientRepository<any> {
  constructor(clientService: ClientService) {
    super(
      clientService,
      "schemas.schCFG_IREF_Item_FVO.records",
      "valueOverrideID",
    );
  }

  public getIrefItemFvosByItemID(itemID: string) {
    return super.getFilteredByValue("itemID", itemID);
  }
}
